import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {StudiewijzerlinkjesNewFacade} from '../../state/studiewijzerlinkjes/studiewijzerlinkjes.facade';

@Component({
  selector: 'app-studiewijzerlinkjes-detail-new',
  templateUrl: './studiewijzerlinkjes-detail-new.component.html',
  styleUrls: ['./studiewijzerlinkjes-detail-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudiewijzerlinkjesDetailNewComponent implements OnInit {

  constructor(store: StudiewijzerlinkjesNewFacade) { }

  ngOnInit(): void {
  }

}
